
import Vue from 'vue';
import { HeadlineAuthor, HeadlineTitle, HeadlineImage, HeadlinePublishDate } from '@headlines/components/fragments';
import { HeadlineWithRelatedArticles } from '@headlines/types/headline';
import getItemFromObject from 'lodash/get';

interface Props {
  data: {
    items: HeadlineWithRelatedArticles[];
  };
  settings: Record<string, unknown>;
}

interface Methods {
  removeCustomerDataEntry: (id: HeadlineWithRelatedArticles['id']) => Promise<void>;
  getItemFromObject: typeof getItemFromObject;
}

export default Vue.extend<unknown, Methods, unknown, Props>({
  components: {
    HeadlineAuthor,
    HeadlineImage,
    HeadlineTitle,
    HeadlinePublishDate,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    settings: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async removeCustomerDataEntry(id) {
      if (this.settings.customerDataType) {
        switch (this.settings.customerDataType) {
          case 'reading-history':
            this.$eventHandler.emit('delete-reading-history-entry', id);
            break;

          default:
            this.$eventHandler.emit('delete-bookmark', id);
            break;
        }
      } else {
        this.$eventHandler.emit('delete-bookmark', id);
      }
    },
    getItemFromObject,
  },
});
